import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PropTypes from "prop-types";
import React, { useCallback, useRef, useState } from "react";
import Overlay from "react-bootstrap/Overlay";
import Popover from "react-bootstrap/Popover";

const AgentAlertPopover = ({ children, placement = "auto"}) => {
  const [showPopover, setShowPopover] = useState(false);
  const popoverTarget = useRef(null);

  const togglePopover = useCallback((event) => {
    setShowPopover((prevShow) => !prevShow);
    popoverTarget.current = event.target;
  }, []);

  const handleClose = useCallback(() => {
    setShowPopover(false);
  }, []);

  return (
    <>
      {children({ togglePopover })}

      <Overlay
        show={showPopover}
        target={popoverTarget.current}
        placement={placement}
        containerPadding={40}
        onHide={handleClose}
        flip
      >
        <Popover id="popover-agent-alerts-panel" className="border-0">
          <button
            type="button"
            className="close position-absolute popover-close-button"
            onClick={handleClose}
          >
            <FontAwesomeIcon icon={["fas", "times"]} size="sm" />
          </button>

          <Popover.Content className="text-white bg-green-lighter rounded">
            <h3>Upgrade your Subscription</h3>

            <p className="text-dark mb-3">
              Stay up to date on potential contacts with Agent Alerts
            </p>

            <a
              href="/billing"
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-success"
            >
              Upgrade your Subscription
            </a>
          </Popover.Content>
        </Popover>
      </Overlay>
    </>
  );
};

AgentAlertPopover.propTypes = {
  children: PropTypes.func.isRequired,
  placement: PropTypes.string,
};

export default AgentAlertPopover;
